"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESOURCES = exports.DOCUMENT_VERSIONS_ENDPOINTS = exports.PROJECT_NOTES_ENDPOINT = exports.CLIENT_NOTES_ENDPOINT = exports.ENTITY_ENDPOINTS = exports.GEO_ENDPOINTS = exports.ENTITY_PROFILES_ENDPOINTS = exports.CHECK_ENTITY_PLAN_ENDPOINT = exports.CONTACT_PERSON_ENDPOINTS = exports.CLIENT_ENDPOINTS = exports.GOOGLE_ENDPOINTS = exports.LITIGATION_ENDPOINTS = exports.AUTH_ENDPOINTS = void 0;

var _index = require("./index");

var AUTH_ENDPOINTS = {
  ACTIVATE_ACCOUNT: '/auth/verify/',
  FORGOT_PASSWORD: '/auth/password/reset/',
  LOGIN: '/auth/login/',
  LOGIN_OTP: '/auth/otp/login/',
  REFRESH_TOKEN: '/auth/token/refresh/',
  RESET_PASSWORD: '/auth/password/reset/confirm/',
  SIGNUP: '/auth/signup/'
};
exports.AUTH_ENDPOINTS = AUTH_ENDPOINTS;
var LITIGATION_ENDPOINTS = {
  CHECK: '/litigations/check/',
  SYNC: '/litigations/{id}/sync/'
};
exports.LITIGATION_ENDPOINTS = LITIGATION_ENDPOINTS;
var GOOGLE_ENDPOINTS = {
  SYNC: '/users/me/google/sync/',
  UNSYNC: '/users/me/google/unsync/'
};
exports.GOOGLE_ENDPOINTS = GOOGLE_ENDPOINTS;
var CLIENT_ENDPOINTS = {
  UPDATE: '/clients/{id}/onboarding/'
};
exports.CLIENT_ENDPOINTS = CLIENT_ENDPOINTS;
var CONTACT_PERSON_ENDPOINTS = {
  CONFIRM: '/contact-persons/confirm/',
  RESEND_CONFIRMATION: '/contact-persons/{id}/resend/'
};
exports.CONTACT_PERSON_ENDPOINTS = CONTACT_PERSON_ENDPOINTS;
var CHECK_ENTITY_PLAN_ENDPOINT = '/entity-plans/check/';
exports.CHECK_ENTITY_PLAN_ENDPOINT = CHECK_ENTITY_PLAN_ENDPOINT;
var ENTITY_PROFILES_ENDPOINTS = {
  GET_BELONGING_ENTITIES: '/entity-profiles/',
  CONFIRM: '/entity-profiles/confirm/'
};
exports.ENTITY_PROFILES_ENDPOINTS = ENTITY_PROFILES_ENDPOINTS;
var GEO_ENDPOINTS = {
  GET_COUNTRIES: '/geo/countries/',
  GET_STATES: '/geo/states/'
};
exports.GEO_ENDPOINTS = GEO_ENDPOINTS;
var ENTITY_ENDPOINTS = {
  GET_AZURE_SAS: '/entities/{id}/sas/'
};
exports.ENTITY_ENDPOINTS = ENTITY_ENDPOINTS;
var CLIENT_NOTES_ENDPOINT = '/clients/{clientID}/notes/{id}';
exports.CLIENT_NOTES_ENDPOINT = CLIENT_NOTES_ENDPOINT;
var PROJECT_NOTES_ENDPOINT = '/projects/{projectID}/notes/';
exports.PROJECT_NOTES_ENDPOINT = PROJECT_NOTES_ENDPOINT;
var DOCUMENT_VERSIONS_ENDPOINTS = {
  MAIN: '/documents/{id}/versions/',
  WITH_VERSION_ID: '/documents/{id}/versions/{versionId}/'
};
exports.DOCUMENT_VERSIONS_ENDPOINTS = DOCUMENT_VERSIONS_ENDPOINTS;
var RESOURCES = {
  addendums: new _index.Resource('addendums'),
  ambassadorCodes: new _index.Resource('ambassadorCodes'),
  ambassadorCodeUsages: new _index.Resource('ambassadorCodeUsages'),
  appeals: new _index.Resource('appeals'),
  bpiNotifications: new _index.Resource('bpiNotifications'),
  bpiSubscriptions: new _index.Resource('bpiSubscriptions'),
  clientAddresses: new _index.Resource('clientAddresses'),
  clientBankAccounts: new _index.Resource('clientBankAccounts'),
  clientGroups: new _index.Resource('clientGroups'),
  clientPermissions: new _index.Resource('clientPermissions'),
  clients: new _index.Resource('clients'),
  companies: new _index.Resource('companies'),
  contactPersons: new _index.Resource('contactPersons'),
  contracts: new _index.Resource('contracts'),
  devices: new _index.Resource('devices'),
  documents: new _index.Resource('documents'),
  documentSeries: new _index.Resource('documentSeries', '/series/{id}/'),
  documentTemplates: new _index.Resource('documentTemplates'),
  emails: new _index.Resource('emails'),
  empowerments: new _index.Resource('empowerments'),
  entities: new _index.Resource('entities'),
  entityPlans: new _index.Resource('entityPlans'),
  entityPreferences: new _index.Resource('entityPreferences', '/entities/{id}/preferences/'),
  entityProfiles: new _index.Resource('entityProfiles'),
  entityReports: new _index.Resource('entityReports', '/entities/{id}/reports/'),
  googleCalendars: new _index.Resource('googleCalendars', '/users/me/google/calendars/'),
  googleProfile: new _index.Resource('googleProfile', '/users/me/google/profile/'),
  groups: new _index.Resource('groups'),
  hearings: new _index.Resource('hearings'),
  iapTransactions: new _index.Resource('iapTransactions'),
  legalObjectCategories: new _index.Resource('legalObjectCategories'),
  legalObjects: new _index.Resource('legalObjects'),
  logs: new _index.Resource('logs'),
  notifications: new _index.Resource('notifications'),
  parties: new _index.Resource('parties'),
  partySubscriptions: new _index.Resource('partySubscriptions'),
  personRoles: new _index.Resource('personRoles'),
  persons: new _index.Resource('persons'),
  phases: new _index.Resource('phases'),
  plans: new _index.Resource('plans'),
  projectPermissions: new _index.Resource('projectPermissions'),
  projects: new _index.Resource('projects'),
  promoCodeUsages: new _index.Resource('promoCodeUsages'),
  subscriptions: new _index.Resource('subscriptions'),
  tasks: new _index.Resource('tasks'),
  taskTimeLogs: new _index.Resource('taskTimeLogs'),
  terms: new _index.Resource('terms'),
  termsResponses: new _index.Resource('termsResponses'),
  tickets: new _index.Resource('tickets'),
  users: new _index.Resource('users'),
  usersEntity: new _index.Resource('usersEntity', '/users/{id}/entity/'),
  usersPreferences: new _index.Resource('usersPreferences', '/users/{id}/preferences/')
};
exports.RESOURCES = RESOURCES;